/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/RawDataRowColumn', 'model/RawDataRowError'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./RawDataRowColumn'), require('./RawDataRowError'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.RawDataRowReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.RawDataRowColumn, root.ForStractionServiceApi.RawDataRowError);
  }
}(this, function(ApiClient, RawDataRowColumn, RawDataRowError) {
  'use strict';




  /**
   * The RawDataRowReport model module.
   * @module model/RawDataRowReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>RawDataRowReport</code>.
   * @alias module:model/RawDataRowReport
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>RawDataRowReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RawDataRowReport} obj Optional instance to populate.
   * @return {module:model/RawDataRowReport} The populated <code>RawDataRowReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Columns')) {
        obj['Columns'] = ApiClient.convertToType(data['Columns'], [RawDataRowColumn]);
      }
      if (data.hasOwnProperty('Errors')) {
        obj['Errors'] = ApiClient.convertToType(data['Errors'], [RawDataRowError]);
      }
      if (data.hasOwnProperty('SourceID')) {
        obj['SourceID'] = ApiClient.convertToType(data['SourceID'], 'Integer');
      }
      if (data.hasOwnProperty('ExternalIdentifier')) {
        obj['ExternalIdentifier'] = ApiClient.convertToType(data['ExternalIdentifier'], 'String');
      }
      if (data.hasOwnProperty('IsProcessed')) {
        obj['IsProcessed'] = ApiClient.convertToType(data['IsProcessed'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/RawDataRowColumn>} Columns
   */
  exports.prototype['Columns'] = undefined;
  /**
   * @member {Array.<module:model/RawDataRowError>} Errors
   */
  exports.prototype['Errors'] = undefined;
  /**
   * @member {Integer} SourceID
   * @default 0
   */
  exports.prototype['SourceID'] = 0;
  /**
   * @member {String} ExternalIdentifier
   * @default ''
   */
  exports.prototype['ExternalIdentifier'] = '';
  /**
   * @member {Boolean} IsProcessed
   * @default false
   */
  exports.prototype['IsProcessed'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


